/**
 *  @class
 *  @function SlideShow
 */
if (!customElements.get('slide-show')) {
  class SlideShow extends HTMLElement {
    constructor() {
      super();

    }

    connectedCallback() {
      const slideshow = this;
      const slides = Array.from(slideshow.querySelectorAll('.carousel__slide'));
      const dots = slideshow.dataset.dots === 'true';
      const autoplay = slideshow.dataset.autoplay === 'false' ? false : parseInt(slideshow.dataset.autoplay, 10);
      const align = slideshow.dataset.align === 'center' ? 'center' : 'left';
      const fade = slideshow.dataset.fade === 'true';
      const prevButton = slideshow.querySelector('.flickity-prev');
      const nextButton = slideshow.querySelector('.flickity-next');
      const customDots = slideshow.querySelector('.flickity-page-dots');
      const rightToLeft = document.dir === 'rtl';
      let selectedIndex = 0;
      const args = {
        wrapAround: true,
        cellAlign: align,
        pageDots: dots,
        contain: true,
        fade: fade,
        autoPlay: autoplay,
        rightToLeft: rightToLeft,
        prevNextButtons: false,
        cellSelector: ".carousel__slide",
        on: {},
      };

      if (slides.length < 1) return;

      if (slideshow.classList.contains('main-slideshow')) {
        if (slideshow.classList.contains('desktop-height-image') || slideshow.classList.contains('mobile-height-image')) {
          args.adaptiveHeight = true;
        }

        args.on.ready = function () {
          const flkty = this;

          flkty.resize();

          // Custom Dots.
          if (dots && customDots) {
            const dots = customDots.querySelectorAll('li');
            dots.forEach((dot, i) => {
              dot.addEventListener('click', () => {
                // flkty.select(i, false, false);
                makeGhostFadeTo(flkty, i);
              });
            });
            dots[this.selectedIndex].classList.add('is-selected');
          }

          // Video Support.
          const videoContainer = flkty.cells[0].element.querySelector('.slideshow__slide-video-bg');
          if (videoContainer) {
            const iframe = videoContainer.querySelector('iframe');
            const video = videoContainer.querySelector('video');

            const loadVideo = () => {
              if (iframe && iframe.classList.contains('lazyload')) {
                iframe.addEventListener('lazybeforeunveil', () => {
                  slideshow.videoPlay(videoContainer);
                });
                lazySizes.loader.checkElems();
              } else if (video) {
                slideshow.videoPlay(videoContainer);
              }
            };

            if (iframe) {
              iframe.onload = loadVideo;
            } else if (video) {
              video.onloadstart = loadVideo;
            }
          }
        };

        args.on.change = function (index) {
          const flkty = this;

          // Color changes.
          const colorText = getComputedStyle(this.selectedElement).getPropertyValue('--color-body');
          const dotsWrapper = slideshow.querySelector('.flickity-custom-navigation-wrapper');
          if (dotsWrapper) {
            dotsWrapper.style.setProperty('--color-body', colorText);
          }

          // Custom Dots.
          if (dots && customDots) {
            const dots = customDots.querySelectorAll('li');
            dots.forEach((dot, i) => {
              dot.classList.remove('is-selected');
            });
            dots[this.selectedIndex].classList.add('is-selected');
          }

          // AutoPlay
          if (autoplay) {
            flkty.stopPlayer();
            flkty.playPlayer();
          }

          // Video Support.
          const previousIndex = fizzyUIUtils.modulo(this.selectedIndex - 1, this.slides.length);

          const videoContainerPrev = flkty.cells[previousIndex].element.querySelector('.slideshow__slide-video-bg');
          if (videoContainerPrev) {
            slideshow.videoPause(videoContainerPrev);
          }

          const videoContainer = flkty.cells[index].element.querySelector('.slideshow__slide-video-bg');
          if (videoContainer) {
            slideshow.videoPlay(videoContainer);
          }


        };
      }
      this.flkty = new Flickity(slideshow, args);

      // ---- Ensure wrap (last↔first) also cross-fades using a temporary ghost layer ----
      const viewport = slideshow.querySelector('.flickity-viewport');
      const slider   = slideshow.querySelector('.flickity-slider');
      const makeGhostFadeTo = (flk, toIndex) => {
        const cell = flk.cells[toIndex].element;
        const ghost = cell.cloneNode(true);
        ghost.classList.add('wrap-ghost');
        Object.assign(ghost.style, {
          position: 'absolute',
          inset: '0',
          margin: 0,
          opacity: '0',
          transition: 'opacity 0.6s ease',
          pointerEvents: 'none',
          zIndex: 5
        });

        // --- PRE-UPDATE: move custom dots immediately to the target to avoid lag ---
        try {
          const customDots = slideshow.querySelector('.flickity-page-dots');
          if (customDots) {
            const items = customDots.querySelectorAll('li');
            items.forEach((dot, i) => dot.classList.toggle('is-selected', i === toIndex));
          }
        } catch(e) { /* no-op */ }

        // --- TEMP: force dot animation speed to match fade duration (avoid mismatch with autoplay length) ---
        const prevDotSpeed = slideshow.style.getPropertyValue('--dot-speed');
        slideshow.style.setProperty('--dot-speed', '0.6s');

        (viewport || slider || slideshow).appendChild(ghost);
        // force reflow then fade-in
        void ghost.offsetWidth;
        ghost.style.opacity = '1';
        const done = (e) => {
          if (e && e.propertyName !== 'opacity') return;
          // Snap Flickity instantly to the target, then remove the ghost
          flk.select(toIndex, /*isWrapped*/ false, /*isInstant*/ true);
          ghost.removeEventListener('transitionend', done);
          ghost.remove();
          // restore previous dot speed (if any)
          if (prevDotSpeed) slideshow.style.setProperty('--dot-speed', prevDotSpeed);
          else slideshow.style.removeProperty('--dot-speed');
        };
        ghost.addEventListener('transitionend', done, { once: true });
      };

      selectedIndex = this.flkty.selectedIndex;

      if (prevButton) {
        const last = slides.length - 1;

        const goPrev = (ev) => {
          if (ev) {
            if (ev.type === 'keyup' && ev.key !== 'Enter' && ev.key !== ' ') return;
            if (typeof ev.preventDefault === 'function') ev.preventDefault();
            if (typeof ev.stopPropagation === 'function') ev.stopPropagation();
          }
          if (!this.flkty) return;
          const target = (this.flkty.selectedIndex === 0) ? (slides.length - 1) : (this.flkty.selectedIndex - 1);
          makeGhostFadeTo(this.flkty, target);
        };

        const goNext = (ev) => {
          if (ev) {
            if (ev.type === 'keyup' && ev.key !== 'Enter' && ev.key !== ' ') return;
            if (typeof ev.preventDefault === 'function') ev.preventDefault();
            if (typeof ev.stopPropagation === 'function') ev.stopPropagation();
          }
          if (!this.flkty) return;
          const target = (this.flkty.selectedIndex === (slides.length - 1)) ? 0 : (this.flkty.selectedIndex + 1);
          makeGhostFadeTo(this.flkty, target);
        };

        // ---- Make autoplay / dots also always cross-fade via ghost ----
        if (this.flkty) {
          const lastIndex = () => this.flkty.slides.length - 1;

          this.flkty.next = (isWrap) => {
            const cur = this.flkty.selectedIndex;
            const target = (cur === lastIndex()) ? 0 : cur + 1;
            makeGhostFadeTo(this.flkty, target);
          };

          this.flkty.previous = (isWrap) => {
            const cur = this.flkty.selectedIndex;
            const target = (cur === 0) ? lastIndex() : cur - 1;
            makeGhostFadeTo(this.flkty, target);
          };
        }

        prevButton.addEventListener('click', goPrev);
        prevButton.addEventListener('keyup', goPrev);
        nextButton.addEventListener('click', goNext);
        nextButton.addEventListener('keyup', goNext);
      }

      if (Shopify.designMode) {
        slideshow.addEventListener('shopify:block:select', (event) => {
          const index = slides.indexOf(event.target);
          this.flkty.select(index);
        });
      }
    }

    videoPause(videoContainer) {
      setTimeout(() => {
        if (videoContainer.dataset.provider === 'hosted') {
          videoContainer.querySelector('video').pause();
        } else if (videoContainer.dataset.provider === 'youtube') {
          videoContainer.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            event: "command",
            func: "pauseVideo",
            args: ""
          }), "*");
        } else if (videoContainer.dataset.provider === 'vimeo') {
          videoContainer.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            method: "pause"
          }), "*");
        }
      }, 10);
    }

    videoPlay(videoContainer) {
      setTimeout(() => {
        if (videoContainer.dataset.provider === 'hosted') {
          videoContainer.querySelector('video').play();
        } else if (videoContainer.dataset.provider === 'youtube') {
          videoContainer.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            event: "command",
            func: "playVideo",
            args: ""
          }), "*");
        } else if (videoContainer.dataset.provider === 'vimeo') {
          videoContainer.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            method: "play"
          }), "*");
        }
      }, 10);
    }
  }

  customElements.define('slide-show', SlideShow);
}
